import {isAdmin, isParent, isStaff, isStudent} from "@/app/util/userUtils";
import UserInfo from "../../types/UserInfo";

/**
 * Get info about the user
 */
export default function getUserData(
	userInfo: UserInfo | null,
	campusId: string | null
) {
	return {
		isLoggedIn: !!userInfo,
		isAdmin: userInfo && isAdmin(userInfo),
		isStaff: userInfo && isStaff(userInfo),
		isStudent: userInfo && isStudent(userInfo),
		isParent: userInfo && isParent(userInfo),
		currentCampus: campusId,
		userEmail: userInfo?.email,
		userHomeCampus: userInfo?.campus_id,
	};
}
